import React from "react"
import { Box, Typography } from '@mui/material';

const PageHeader = ({ content, pLeft = '29%', pRight = '31%', fSizeMobile = 59 }) => {


    const style = {
        boxSection1: {
            height: { xs: 80, md: 100 },
            color: '#fff',
            bgcolor: '#F11A7B',
            marginTop: { xs: 1, md: "2vh" },
            marginBottom: { xs: 3, md: "5vh" },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'rotate(-2deg)',
        },
        boxTypoGraphy: {
            fontFamily: 'Poppins-Black',
            fontWeight: 900,
            fontSize: { xs: fSizeMobile, md: 86 },
            transform: 'rotate(2deg)',
            position: 'absolute',
            // top: { xs: 6, md: 12 },
            // left: 16,
            // letterSpacing: { xs: 0, md: '12px' },
            textShadow: '0px 0px 0 #ffffff, -2px 0px 0 #ffffff'
            // rgb(255, 255, 255) 0px 0px 0px, rgb(255, 255, 255) -3px 0px 0px
        },
    };

    return (
        <Box sx={{ paddingLeft: { xs: 0, md: pLeft }, paddingRight: { xs: 0, md: pRight } }}>
            <Box sx={style.boxSection1} >
                <Typography sx={{ ...style.boxTypoGraphy }}>{content}</Typography>
            </Box>
        </Box>
    )
};

export default PageHeader